import { LeagueFieldBaseValue } from './league-field-base-value';
import { ModelInstance, ToBackHook, ToFrontHook } from './util';
import { File } from './file';
import { LeaguePlayerField } from './league-player-field';

@ModelInstance({
  mappingFields: {
    id: 'id',
    league_player_field_id: 'leaguePlayerFieldId',
    league_player_field: 'leaguePlayerField',
    value: 'value',
    file: 'file',
    value_text: 'valueText',
  },
  relation: {
    file: File,
    leaguePlayerField: LeaguePlayerField
  }
})
export class LeaguePlayerFieldValue extends LeagueFieldBaseValue {
  leaguePlayerFieldId: number;
  leaguePlayerField: LeaguePlayerField;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
